import { render, staticRenderFns } from "./BgSection.vue?vue&type=template&id=499feb64&scoped=true"
import script from "./BgSection.vue?vue&type=script&lang=js"
export * from "./BgSection.vue?vue&type=script&lang=js"
import style0 from "./BgSection.vue?vue&type=style&index=0&id=499feb64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499feb64",
  null
  
)

export default component.exports